const workTags = [
  'Security', 'Mobile App', 'Web App', 'Automation', 'IOT', 'Gaming', 'Miscellaneous', 'All',
];

export default workTags;
